/** @format */

import { defaultActions } from '../../core/actionsDefault';

// const _ = require('underscore');

export const ipConstants = {
    LIST_POOL: 'ip_pool_list',
    LIST_POOL_NUMBERS: 'ip_pool_list_number',
    LIST_POOL_ITEM: 'ip_pool_item',
    LIST_POOL_ITEM_LIST: 'ip_pool_item_list',
    LIST_POOL_ADD_NEW: 'ip_pool_add_new',
    LIST_POOL_EDIT: 'ip_pool_add_edit',
    LIST_POOL_EDIT_SAVE: 'ip_pool_add_edit',
    LIST_POOL_NO_ACTION: 'ip_pool_no_action',
    LIST_POOL_DELETE: 'ip_pool_delete',

    LIST_POOL_NAME_SELECT: 'ip_pool_name_select',
    LIST_POOL_NUMBERS_CHOOSE: 'ip_pool_numbers_choose',
};

export class ipActions extends defaultActions {
    static getListPool = (url, filter, actionType, callback, options) =>
        defaultActions.getCollection(url, filter, [{ name: 'ip', value: 'asc' }], actionType, callback, options);
}
